import React from 'react';

const About=()=>{
    return (
        <div className="about">
        <h1 className="about--title">About</h1>
        <p className="about--paragraph">A passionate software developer embodies a unique set of qualities that enable them to excel in the field. her curiosity, problem-solving mindset, attention to detail, collaboration and communication skills, innovation, creativity, adaptability, and resilience drive them to constantly strive for excellence. </p>
        </div>
        
    )
}

export default About;